import Image from 'next/image';
import { useProductPageContext } from '@/components/v2/product/hooks/useProductPageContext';

const KeyFeatures = () => {
  const { product } = useProductPageContext();

  // Get features
  const features = product.features ?? [];

  // Don't render if no features
  if (features.length === 0) {
    return null;
  }

  // Sort features by sequence
  const sortedFeatures = features.sort((a, b) => {
    if (a.sequence < b.sequence) {
      return -1;
    }

    if (a.sequence > b.sequence) {
      return 1;
    }

    return 0;
  });

  return (
    <div className="space-y-2 md:col-span-6 xl:col-span-4">
      {sortedFeatures.map((feature, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div
          key={index}
          className="flex items-center gap-x-2 rounded-md bg-white p-4 text-sm text-gray-700 shadow-[0_4px_10px_0_rgba(14,_113,_251,_0.30)]"
        >
          {feature.image?.url && (
            <Image
              src={feature.image?.url}
              alt={feature.name}
              width={20}
              height={20}
              className="shrink-0"
            />
          )}
          {feature.value}
        </div>
      ))}
    </div>
  );
};

export default KeyFeatures;
